import { z } from "zod";
import { panSchema } from "../common";
import { belongsToEnum } from "./onboarding";

export const SecondHolderPersonalInfoSchema = z.object({
  name: z.string().min(1, "Name is required"),
  pan: panSchema,
  gender: z.string().min(1, "Gender is required"),
  date_of_birth: z.string().min(1, "Date of birth is required"),
});

export const SecondHolderContactDetailsSchema = z.object({
  number: z
    .string()
    .min(1, "Mobile is required")
    .regex(/^\d{10}$/, "Phone number must be 10 digits"),
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  phone_belongs_to: belongsToEnum,
  email_belongs_to: belongsToEnum,
  isd: z.string(),
});

export const SecondHolderOtherInfoSchema = z.object({
  occupation: z.string().min(1, "Occupation is required"),
  source_of_wealth: z.string().min(1, "Income source is required"),
  income_slab: z.string().min(1, "Income range is required"),
  pep_details: z.string().min(1, "Political exposure is required"),
});
